import styled from 'styled-components'

import { _M_Normal, Button, mainColors, rgba, shadowColors } from '@avantstay/backoffice-core'
import { IconChevronDown } from '@avantstay/backoffice-vectors'

export const Root = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`

export const PrimaryButton = styled(Button.Primary)<{ $hasMenu: boolean }>`
  width: auto;
  white-space: nowrap;
  padding-right: ${({ $hasMenu }) => ($hasMenu ? '44px' : undefined)};
`

export const MenuToggle = styled.button`
  position: absolute;
  inset: 0 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  padding: 0;
  border: 0;
  border-left: 1px solid ${rgba(mainColors.white, 0.3)};
  border-radius: 0 4px 4px 0;
  background: transparent;
  color: ${mainColors.white};
  cursor: pointer;

  &:hover,
  &[data-open='true'] {
    background: ${rgba(mainColors.black, 0.1)};
  }

  &:disabled {
    cursor: not-allowed;
    background: transparent;
  }
`

export const ToggleIcon = styled(IconChevronDown)<{ $isOpen: boolean }>`
  width: 16px;
  height: 16px;
  transform: ${({ $isOpen }) => ($isOpen ? 'scaleY(-1)' : undefined)};
`

export const Menu = styled.div`
  min-width: 200px;
  padding: 8px 0;
  background: ${mainColors.white};
  border: 1px solid ${mainColors.neutralLight};
  border-radius: 4px;
  box-shadow: 0 4px 16px ${rgba(shadowColors.blur, 0.4)};
`

export const MenuItem = styled.button`
  ${_M_Normal};

  display: block;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: ${mainColors.neutralExtremelyDark};
  text-align: left;
  white-space: nowrap;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: ${mainColors.neutralLight};
  }
`
